export { InPageChannelPackLineup as default } from "./inpage-channel-pack-lineup";
export type { InPageChannelPackLineupProps } from "./inpage-channel-pack-lineup";
